// import React from 'react';
// import { Navigate, Outlet, useLocation } from 'react-router-dom';
// import { signIn } from './constant';
// import { setRedirectParams } from '../helper';

// const PrivateRoute = () => {
//   const location = useLocation();
//   const isAuthenticated = localStorage.getItem('token') !== null;

//   if (isAuthenticated) {
//     return <Outlet />;
//   } else {
//     setRedirectParams(location.pathname + location.search);
//     return <Navigate to={signIn} />;
//   }
// };

// export default PrivateRoute;

import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { signIn } from "./constant";
import {
  getParamsFromURL,
  modifyEncodedURLParams,
  setRedirectParams,
} from "../helper";

const PrivateRoute = () => {
  const location = useLocation();
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );

  const [isProcessingToken, setIsProcessingToken] = useState(true);

  useEffect(() => {
    const fetchAndProcessToken = async () => {
      const params = await getParamsFromURL(location);

      if (params) {
        const token = params["token"];
        if (token) {
          localStorage.setItem("token", token);
          // Remove token from encrypted params and update the URL
          const updatedUrl = await modifyEncodedURLParams(
            window.location.href,
            "token",
            "remove"
          );
          window.history.replaceState({}, "", updatedUrl);

          setIsAuthenticated(true);
        } else {
          const storedToken = localStorage.getItem("token");
          if (storedToken) {
            setIsAuthenticated(true);
          }
        }
      }
      setIsProcessingToken(false);
    };

    fetchAndProcessToken();
  }, [location]);

  if (isProcessingToken) {
    return null; // Show nothing or a loading state while processing
  }

  if (isAuthenticated) {
    return <Outlet />;
  } else {
    setRedirectParams(location.pathname + location.search);
    return <Navigate to={signIn} />;
  }
};

export default PrivateRoute;
